export const EVENTS = {
    cycleIndexChanged:'cycle-index-changed',
    periodIndexChanged:'period-index-changed',
    periodsChanged:'periods-changed',

    openAppDrawer:'open-app-drawer',
    closeAppDrawer:'close-app-drawer',

    openForgetPasswordDialog:'open-forget-password-dialog',
    closeForgetPasswordDialog:'close-forget-password-dialog',
    
    openSignupDialog:'open-signup-dialog',
    closeSignupDialog:'close-signup-dialog',
    
    openAccountDialog:'open-account-dialog',
    closeAccountDialog:'close-account-dialog',
    
    consultAccountMode:'consult-account-mode',
    editAccountMode:'edit-account-mode',
}